<template>
  <b-card
    class="news-details-bar"
    no-body
  >
    <b-card-header class="border-bottom">
      <b-card-title class="font-weight-bold text-secondary font-medium-3">
        <span>{{ barData.title }}</span>
      </b-card-title>
    </b-card-header>
    <div class="mt-2 mb-2">
      <!-- Stats Card Vertical -->
      <b-row class="match-height mx-1 font-medium-1 font-weight-bold text-dark">
        <b-col cols="2">
          {{ barData.tableLeftTitle }}
        </b-col>
        <b-col cols="8" />
        <b-col cols="2">
          {{ barData.tableRightTitle }}
        </b-col>
      </b-row>
      <b-row
        v-for="(item, index) in barData.list"
        :key="`bar-item-${index}`"
        class="match-height mx-1 mt-1 font-medium-1"
      >
        <b-col
          cols="2"
        >
          {{ item.left }}
        </b-col>
        <b-col
          cols="8"
        >
          <b-progress
            v-b-tooltip.hover
            max="100"
            height="20px"
            variant="secondary"
            class="mb-1"
            :title="`${item.bar}%`"
          >
            <b-progress-bar :value="item.bar">
              <span><strong>{{ item.bar }}%</strong></span>
            </b-progress-bar>
          </b-progress>
        </b-col>
        <b-col
          cols="2"
        >
          {{ item.right.toLocaleString() }}
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
    BRow, BCol, BCard, BCardTitle, BProgress, BProgressBar, BCardHeader, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BCardTitle,
        BProgress,
        BProgressBar,
        BCardHeader,
    },
    directives: {
        Ripple,
        'b-tooltip': VBTooltip,
    },
    props: {
        barData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {}
    },
}
</script>
<style>
.news-details-bar .progress-bar {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}
</style>
